import { translate as t } from '@thoughtspot/i18n';
import { Link } from '@thoughtspot/radiant-react/widgets/link';
import { CellType } from '@thoughtspot/radiant-react/widgets/table/table-list-view/cell/cell-type-service';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import cx from 'classnames';
import React from 'react';
import { GitConfigsMappingStatus, } from "../../../services/generated/graphql-types";
import { Horizontal } from "../../../utils/layouts";
import { DetailsConstant, TranslationKeys } from '../constant';
import styles from './all-org-configuration-details.module.scss';
export var ConfigColumnHeaders;
(function (ConfigColumnHeaders) {
    ConfigColumnHeaders["ORG"] = "orgName";
    ConfigColumnHeaders["STATUS"] = "mappingStatus";
    ConfigColumnHeaders["REPOSITORY"] = "repositoryUrl";
    ConfigColumnHeaders["BRANCH"] = "branchName";
    ConfigColumnHeaders["ACTIONS"] = "moreOptions";
})(ConfigColumnHeaders || (ConfigColumnHeaders = {}));
export var MappingStatus;
(function (MappingStatus) {
    MappingStatus["MAPPED"] = "Mapped";
    MappingStatus["UNMAPPED"] = "Unmapped";
})(MappingStatus || (MappingStatus = {}));
export var ListActionTypes;
(function (ListActionTypes) {
    ListActionTypes["EDIT"] = "edit";
    ListActionTypes["RESET"] = "reset";
    ListActionTypes["ENABLE"] = "enable";
})(ListActionTypes || (ListActionTypes = {}));
export var SortingType;
(function (SortingType) {
    SortingType["ASC"] = "asc";
})(SortingType || (SortingType = {}));
export const sortKeyMap = {
    [ConfigColumnHeaders.ORG]: 'NAME',
    [ConfigColumnHeaders.STATUS]: 'STATUS',
};
export const parseOrgsConfigData = (configs) => {
    return configs?.map(checkConfigs => ({
        id: checkConfigs.org.id.toString(),
        orgName: { text: checkConfigs.org.name },
        mappingStatus: {
            text: checkConfigs?.status === GitConfigsMappingStatus.Mapped
                ? MappingStatus.MAPPED
                : MappingStatus.UNMAPPED,
        },
        repositoryUrl: {
            text: checkConfigs?.repository_url || DetailsConstant.EMPTYDATA,
        },
        branchName: {
            text: checkConfigs?.commit_branch_name || DetailsConstant.EMPTYDATA,
        },
    }));
};
export const generateActionButtons = (context, data) => {
    if (data.repositoryUrl.text === DetailsConstant.EMPTYDATA) {
        return [
            {
                id: ListActionTypes.ENABLE,
                label: t(TranslationKeys.VCS_ADMIN_ORG_ENABLE_VERSION_CONTROL),
                onClick: () => {
                    context.onRowAction({
                        action: ListActionTypes.ENABLE,
                        data,
                    });
                },
            },
        ];
    }
    return [
        {
            id: ListActionTypes.EDIT,
            label: t(TranslationKeys.VCS_ADMIN_RIGHT_PANEL_EDITBTN_TEXT),
            onClick: () => {
                context.onRowAction({
                    action: ListActionTypes.EDIT,
                    data,
                });
            },
        },
        {
            id: ListActionTypes.RESET,
            label: t(TranslationKeys.VCS_ADMIN_ORG_RESET_CONFIG_TEXT),
            onClick: () => {
                context.onRowAction({
                    action: ListActionTypes.RESET,
                    data,
                });
            },
        },
    ];
};
const ActionLinks = ({ links }) => (React.createElement(Horizontal, { className: styles.mainActionLinks }, links.map((link, ind) => (React.createElement(Link, { key: link.id, className: cx(styles.actionLink, {
        [styles.actionLink__rightBorder]: ind < links.length - 1,
    }), onClick: link.onClick }, link.label)))));
export const getColumnDefinitions = () => {
    return [
        {
            cellRendererFramework: (params) => {
                const { orgName } = params.data;
                return (React.createElement(Typography, { variant: "content-label-subhead", className: styles.orgNameInRow }, orgName.text));
            },
            headerName: t(TranslationKeys.VCS_ADMIN_ORG_TABLE_COL_HEADER_NAME),
            headerClass: styles.header,
            colId: ConfigColumnHeaders.ORG,
            field: ConfigColumnHeaders.ORG,
            sortable: true,
            initialSort: SortingType.ASC,
            flex: 1,
        },
        {
            cellRenderer: CellType[CellType.text],
            headerName: t(TranslationKeys.VCS_ADMIN_ORG_STATUS),
            headerClass: styles.header,
            colId: ConfigColumnHeaders.STATUS,
            sortable: true,
            flex: 1,
        },
        {
            cellRenderer: CellType[CellType.text],
            headerName: t(TranslationKeys.VCS_ADMIN_CONFIG_MODAL_REPOSITORY_LABEL),
            headerClass: styles.header,
            colId: ConfigColumnHeaders.REPOSITORY,
            sortable: false,
            flex: 1,
        },
        {
            cellRenderer: CellType[CellType.text],
            headerName: t(TranslationKeys.VCS_ADMIN_CONFIG_MODAL_BRANCH_LABEL),
            headerClass: styles.noBorderHeader,
            colId: ConfigColumnHeaders.BRANCH,
            sortable: false,
            flex: 1,
        },
        {
            cellRendererFramework: (params) => {
                const { context, data } = params;
                const links = generateActionButtons(context, data);
                return React.createElement(ActionLinks, { links: links });
            },
            colId: ConfigColumnHeaders.ACTIONS,
            headerName: '',
            headerClass: styles.header,
            sortable: false,
        },
    ];
};
//# sourceMappingURL=all-orgs.utils.js.map